import React from 'react';
import {Link, browserHistory} from 'react-router';
import {Button} from '@blueprintjs/core';
import { User } from 'api';
import { connect } from 'react-redux';
import cookie from 'react-cookie';
import {Toastr} from 'modules/toastr';
import {msg} from "constants/message";

let loginBg = require('assets/images/bannerLogin.png');
class ResetPassword extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
      isSubmit: false,
      password: '',
      passwordConfirmation: '',
      isConfirmPasswordCorrectly: true,
      isCodeExpire: false
    }
  }

  componentDidMount() {
    if (typeof cookie.load('accessToken') != 'undefined') {
      browserHistory.push('/');
    }
    this.checkCode();
  }

  handleChange(name, e) {
    this.setState({
      [name]: e.target.value,
      isSubmit: false,
      isConfirmPasswordCorrectly: true
    });
  }

  handleResetPassword(e) {
    e.preventDefault();
    this.checkCode().then(() => {
      if (!this.state.isCodeExpire) {
        if (this.handleValidate()) {
          this.setState({loading: true});

          let params = {
            code: this.props.params.code,
            password: this.state.password,
            passwordAgain: this.state.passwordConfirmation
          }
          User.actions.resetPassword.request(null, params).then(res => {
            this.setState({loading: false});
            Toastr('Bạn đã đổi mật khẩu thành công' ,'success');
          }).catch( (error) => {
            this.setState({loading: false});
            if (error.response) {
              Toastr(error.response.data.errors[0].detail,'error');
            }
          });
        }
      }
    });
  }

  checkCode() {
    let params = {
      code: this.props.params.code
    }
    return User.actions.confirmCode.request(null, params).then(res => {
      this.setState({
        isCodeExpire: false
      });
    }).catch((error) => {
      this.setState({
        isCodeExpire: true
      });
    });
  }

  handleValidate() {
    this.setState({isSubmit: true});
    let pass = true;
    if (!this.state.password) {
      pass = false;
    } else if (!this.state.passwordConfirmation) {
      pass = false;
    } else if (this.state.password != this.state.passwordConfirmation) {
      pass = false;
      this.setState({
        isConfirmPasswordCorrectly: false
      });
    }
    return pass;
  }

  handleForgotPassword() {
    browserHistory.push('/quen-mat-khau');
  }

  render() {
    let logoImg = require('assets/images/logo-login.png');
    return (
      <div className="login" style={{backgroundImage: `url(${loginBg})`}}>
        <div className="login-block">
          <h1 className="logo-login">
            <img src={logoImg} alt="" className="login-logo-image"/>
            <span className="login-logo-caption">Phần mềm và xây dựng cơ sở dữ liệu hoạt động thanh tra trên địa bàn Tỉnh Quảng Ngãi</span>
          </h1>
            {
              this.state.isCodeExpire ? (
                <form className="login-form" noValidate>
                  <h2 className="title-login txt-blue">Lỗi xác nhận</h2>
                  <div className="login-group sub-title-login text-danger">
                    Mã xác thực này không hợp lệ hoặc đã được sử dụng. Vui lòng chọn "Quên mật khẩu" để nhận được mã xác thực mới
                  </div>
                  <div className="login-group">
                    <Button type="button" onClick={this.handleForgotPassword.bind(this)} className={`btn-login ${this.state.loading ? 'btn-loading-inline' : ''}`} text="Quên mật khẩu" />
                  </div>
                  <div className="login-group">
                    <p className='txt-center'>
                      <Link to="dang-nhap" className="text-14 txt-blue">Đăng nhập</Link>
                    </p>
                  </div>
                </form>
              ) : (
                <form className="login-form" onSubmit={this.handleResetPassword.bind(this)} noValidate>
                  <h2 className="title-login txt-blue">Tạo mật khẩu mới</h2>
                  <div className="login-group sub-title-login">
                    Vui lòng điền đầy đủ thông tin để tạo mật khẩu mới
                  </div>
                  <div className="login-group">
                    <span className="tt-login-password"></span>
                    <input className={`login-input pt-input ${this.state.isSubmit && !this.state.password ? 'pt-intent-danger' : ''}`}
                      type="password" placeholder="Nhập mật khẩu mới" name="Password" value={this.state.password}
                      onChange={this.handleChange.bind(this, 'password')} autoComplete = "off"
                      maxLength={40}/>
                    {
                      this.state.isSubmit && !this.state.password ?
                      <div className="pt-form-helper-text">{msg.messageDefault}</div>
                      : null
                    }
                  </div>
                  <div className="login-group">
                    <span className="tt-login-password"></span>
                    <input className={`login-input pt-input ${this.state.isSubmit && (!this.state.passwordConfirmation || !this.state.isConfirmPasswordCorrectly) ? 'pt-intent-danger' : ''}`}
                      type="password" placeholder="Xác nhận mật khẩu" name="Password" value={this.state.passwordConfirmation}
                      onChange={this.handleChange.bind(this, 'passwordConfirmation')} autoComplete = "off"
                      maxLength={40}/>
                    {
                      this.state.isSubmit && !this.state.passwordConfirmation ?
                      <div className="pt-form-helper-text">{msg.messageDefault}</div>
                      : null
                    }
                    {
                      this.state.isSubmit && !this.state.isConfirmPasswordCorrectly ?
                      <div className="pt-form-helper-text">Xác nhận mật khẩu không đúng</div>
                      : null
                    }
                  </div>
                  <div className="login-group">
                    <Button type="submit" className={`btn-login ${this.state.loading ? 'btn-loading-inline' : ''}`} text="Đổi mật khẩu" />
                  </div>
                  <div className="login-group">
                    <p className='txt-center'>
                      <Link to="dang-nhap" className="text-14 txt-blue">Đăng nhập</Link>
                    </p>
                  </div>
                </form>
              )
            }
        </div>
      </div>
    );
  }
}

export default connect()(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/modules/reset-password/ResetPassword.jsx